import { render, staticRenderFns } from "./UserProtocol.vue?vue&type=template&id=04403ddd&scoped=true"
import script from "./UserProtocol.vue?vue&type=script&lang=js"
export * from "./UserProtocol.vue?vue&type=script&lang=js"
import style0 from "./UserProtocol.vue?vue&type=style&index=0&id=04403ddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04403ddd",
  null
  
)

export default component.exports